import React, { useEffect } from 'react'
import talktousimg from '../../images/CEOimage.webp'
import '../talktous/talktous.css'
import { FaLinkedinIn } from "react-icons/fa6";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import { FaArrowRightLong } from 'react-icons/fa6'

function Talktous() {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    return (
        <section className='talktous-main'>
            <div className="t-left" data-aos="fade-up-left">
                <img src={talktousimg} alt="" />
                <div className="t-b-info">
                    <span>
                        <h3>Rezi Parulava</h3>
                        <p>Co-Founder of Arttteo</p>
                    </span>
                    <div className="linkedin-circle">
                       <a href="https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Afsd_profile%3AACoAACVU2TUB6xFgVnn8n__I719atw5taxd2lHI&keywords=rezi%20parulava&origin=RICH_QUERY_SUGGESTION&position=0&searchId=496635a4-341b-424e-bbd2-64e114d32c16&sid=89m&spellCorrectionEnabled=false"><FaLinkedinIn /></a> 
                    </div>

                </div>
            </div>
            <div className="t-right" data-aos="fade-up-right">
                <div className="A-title">
                    <span>Talk to us</span>
                    <h1>You Are One Click Away</h1>
                    <p className='title-text'>We’re genuinely passionate about your project and excited to collaborate closely. Let’s dive into the details and transform your vision into reality together! Reach out today, and let’s spark an inspiring conversation!</p>
                    <div className="talktous-buttons">
                        <a className='estimationbuttonlink' href="https://arttteo.com/contact">
                            <button className="estimation-button">
                                <p>Talk to us</p>
                                <div className="arrow-circle">
                                    <FaArrowRightLong />
                                </div>
                            </button>
                        </a>
                        <a className='estimationbuttonlink' href="https://arttteo.com/contact">
                            <button className="estimation-button light">
                                <p>Get our rates card</p>
                                <div className="arrow-circle">
                                    <FaArrowRightLong />
                                </div>
                            </button>
                        </a>
                        <a className='estimationbuttonlink' href="https://arttteo.com/contact">
                            <button className="lightbutton">
                                <p>Get free QA test report</p>
                            </button>
                        </a>
                        <a className='estimationbuttonlink' href="https://arttteo.com/contact">
                            <button className="lightbutton">
                                <p>Get your estimation</p>
                            </button>
                        </a>
                    </div>


                </div>
            </div>

        </section>
    )
}

export default Talktous